import { render, staticRenderFns } from "./ServiceProvider.vue?vue&type=template&id=71054e60&"
import script from "./ServiceProvider.vue?vue&type=script&lang=ts&"
export * from "./ServiceProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports